'use strict';

function EmailSuggestion() {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];
  this.inputSelector = null;
  this._domainList = ['gmail.com', 'hotmail.com', 'yahoo.com', 'yahoo.ca', 'outlook.com', 'live.ca', 'hotmail.ca', 'shaw.ca', 'live.com', 'icloud.com', 'rogers.com', 'telus.net', 'msn.com', 'me.com', 'sympatico.ca', 'bell.net', 'cogeco.ca', 'protonmail.com', 'yopmail.com', 'aol.com'];
  this.analytics = new Analytics();

  this.init = function () {
    this._$node = $(this.node);
    Mailcheck.defaultDomains = this._domainList;
    Mailcheck.defaultSecondLevelDomains = [];
    Mailcheck.defaultTopLevelDomains = [];
  };

  this.initAllReady = function () {
    this._generateContent();
    this._setupEventHandler();
  };

  this._generateContent = function () {
    var contentHtml = '\n      <span>Did you mean </span>\n      <strong class="suggested-domain"></strong>\n      <span>?</span>\n      <a href="#" class="use-suggestion"> Use this</a>';
    this._$node.append(contentHtml);
  };

  this._setupEventHandler = function () {
    var _this = this;

    this._inputElement = $(this.inputSelector);
    this._suggestionElement = this._$node.find('a.use-suggestion');
    this._suggestedEamilValue = null;
    this._suggestedDomain = null;
    if (this._inputElement.length > 0) {
      this._inputElement.on('blur', function () {
        _this._inputElement.mailcheck({
          suggested: function (element, suggestion) {
            this._suggestedEamilValue = suggestion.full;
            this._suggestedDomain = suggestion.domain;
            $('.suggested-domain').html(this._suggestedDomain);
            this._$node.addClass('show');
            this.analytics.forcePushEvent('generic-member-navigation', {
              memberNavigation: ['MogoAccount-Email Domain Suggestion-Show ' + this._suggestedDomain.replace(/-/g, '|') + '-Navigation-Component']
            });
          }.bind(_this),
          empty: function () {
            this._$node.removeClass('show');
          }.bind(_this)
        });
      });
      this._suggestionElement.on('click', function () {
        if (_this._suggestedEamilValue) {
          _this._inputElement.val(_this._suggestedEamilValue);
          _this._$node.removeClass('show');
          _this.analytics.forcePushEvent('generic-member-navigation', {
            memberNavigation: ['MogoAccount-Email Domain Suggestion-Click ' + _this._suggestedDomain.replace(/-/g, '|') + '-Navigation-Component']
          });
        }
      });
    }
  };
}